import { render, staticRenderFns } from "./openAppButton.vue?vue&type=template&id=3b05b9d3&scoped=true"
import script from "./openAppButton.vue?vue&type=script&lang=ts"
export * from "./openAppButton.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./openAppButton.vue?vue&type=style&index=0&id=3b05b9d3&prod&scoped=true&lang=scss")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "3b05b9d3",
  "038a6b9e"
  
)

export default component.exports